import { render } from "./StudentVocPracticeItem.vue?vue&type=template&id=1aba3952&scoped=true"
import script from "./StudentVocPracticeItem.vue?vue&type=script&lang=js"
export * from "./StudentVocPracticeItem.vue?vue&type=script&lang=js"

import "./StudentVocPracticeItem.vue?vue&type=style&index=0&id=1aba3952&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aba3952"]])

export default __exports__